import React, { useContext } from 'react';
import { Table as TanstackTable } from '@tanstack/react-table';
import { DataRecord } from './table.types';

export interface IAvTableV2Context {
  table: TanstackTable<DataRecord>;
  isClickedAll: boolean;
}

export const AvTableV2Context = React.createContext<IAvTableV2Context>({} as IAvTableV2Context);

export const useAvTableV2Context = () => useContext(AvTableV2Context);
